import type { Apollo } from 'src/gql/generated';

export type UserOption = Pick<Apollo.User, '__typename' | 'avatarColor' | 'displayName' | 'id'>;

export const UNASSIGNED_USER_ID = '__unassigned__';

export const UNASSIGNED_OPTION: UserOption = {
  __typename: 'User',
  avatarColor: '',
  displayName: 'Unassigned',
  id: UNASSIGNED_USER_ID,
};
